import { createMobileBannerStore } from 'src/apps/mobile-common/stores/mobileBannerStore';
import {
	getMfaBannerDismissCount,
	incrementMfaBannerDismissCount,
	isMfaBannerDismissed,
	resetMfaBannerDismissCount,
	setMfaBannerDismissed
} from 'src/common/services/api/LocalStorageApi';

export const useMfaBannerStore = createMobileBannerStore({
	isBannerDismissed: isMfaBannerDismissed,
	setBannerDismissed: setMfaBannerDismissed,
	getDismissCount: getMfaBannerDismissCount,
	incrementDismissCount: incrementMfaBannerDismissCount,
	resetDismissCount: resetMfaBannerDismissCount
});
